import {
  call,
  put,
  takeLatest,
  select,
  race,
  take,
  takeEvery
} from "redux-saga/effects";
import { delay } from "redux-saga";
import get from "lodash.get";

import { fetchInitialize, fetchWorkItems, fetchOneWorkItem, cloneWorkitem } from "./Api";
import actions from "actions/actionTypes";
import { selectFieldDetails, selectCurrentMiscFees } from "selector/initializeSelector";
import {
  selectWorkItemById,
  selectWorkListFilters
} from "selector/workItemSelectors";
import {
  updateWorkItemAction,
  setCurrentWorkItemAction,
  fetchWorkItemSuccessAction,
  fetchWorkItemFailedAction,
  fetchWorkItemAction,
  resetWorklistFilter,
  changeWorklistFilter
} from "actions/fetchWorkItemsActions";
import {
  setCurrentStateAction,
  selectDropdownStateAction,
  setFormFieldsAction,
  resetCurrentStateAction
} from "actions/workItemsActions";
import {
    setMiscFeeValue,
    setPre1981DataValue
} from "actions/questionaireActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";
import { closeUrl } from "actions/iframeActions";
import { sanitizeFieldsAction } from "actions/sanitizeActions";
import { apiRequestFailureAction } from "actions/requestActions";
import fetchSaga from "./fetchSaga";
import { actionsFor as paginationActionsFor } from "store/common/pagination/actions";
import { typesFor as paginationTypesFor } from "store/common/pagination/types";
import { selectorsFor as paginationSelectorsFor } from "store/common/pagination/selectors";
import { selectorsFor as sortingSelectorsFor } from "store/common/sorting/selectors";
import { typesFor as sortingTypesFor } from "store/common/sorting/types";
import { sanitizeWorkitemFields } from "utils";
import * as WorkItem from "domain/WorkItem";
import { getPreferences } from "api";
import { mapFeatures } from "mappers/preferences";
import { history } from "../store";
import { getCurrentExternalId } from "selector/userSelectors";

const PaginationActions = paginationActionsFor("worklist");
const PaginationTypes = paginationTypesFor("worklist");
const PaginationSelectors = paginationSelectorsFor("worklist");
const SortingSelectors = sortingSelectorsFor("worklist");
const SortTypes = sortingTypesFor("worklist");

export function* fetchInitializeSaga() {
  yield put(closeUrl());
  yield put(
    setCurrentStateAction({
      abbr: null,
      name: null
    })
  );
  yield put(showLoader());
  try {
    const response = yield call(fetchSaga, fetchInitialize);

    const fieldsObj = get(response, "dualFeesResponse[0].fields");
    yield put(sanitizeFieldsAction(fieldsObj.fieldDetails));
    const [fields, error] = yield race([
      take(actions.SANITIZE_FIELDS_SUCCESS),
      take(actions.SANITIZE_FIELDS_FAILURE)
    ]);

    if (error) throw error.payload;

    const payload = { ...response };
    payload.fields = { ...fieldsObj, fieldDetails: fields.payload };
    yield put({
      type: actions.FETCH_INITIALIZE_SUCCESS,
      payload
    });
  } catch (error) {
    yield put({
      type: actions.FETCH_INITIALIZE_FAILED,
      payload: error.message
    });
  }
  yield put(hideLoader());
}

export function* selectWorkItemSaga(action) {
  yield put(showLoader());

  yield put(
    setCurrentStateAction({
      abbr: null,
      name: null
    })
  );
  const partialWorkItem = yield select(selectWorkItemById(action.payload));
  const workItem = yield call(fetchSaga, fetchOneWorkItem, {
    id: partialWorkItem.workItemId,
    status: get(partialWorkItem, "attributes.status", "")
  });
  yield put(hideLoader());

  if (get(workItem, "attributes.status").toUpperCase() === "COMPLETED") {
    yield put(setCurrentWorkItemAction(workItem));
    yield call(delay, 0);
    yield call([history, "push"], "/Summary");
    return;
  }
  let miscFees = [];
    let pre1981set = [];
    if (workItem.vehicle.length < 23) {
        const vehicle = workItem.vehicle;
        let Make;
        let year;
        if (workItem.dualFeesResponse.filter(a => a.fields !== null).length > 0) {
          workItem.dualFeesResponse.forEach(field => {
            if(field.fields.fieldDetails.filter(a => a.key === "cMake").length){
              Make = field.fields.fieldDetails.filter(a => a.key === "cMake")[0].value;
              year = field.fields.fieldDetails.filter(a => a.key === "cYear")[0].value;
            }
          });
                
        }
        if (Make && year) {
            pre1981set = vehicle.map(function (obj) {
                var rObj = {};
                rObj["state"] = "";
                rObj["sequence"] = obj.sequence;
                rObj["name"] = obj.name;
                rObj["key"] = obj.key;
                rObj["label"] = obj.key;
                //rObj["value"] = obj.value.includes("|") ? obj.value.split("|")[0] : "";
                rObj["value"] = obj.value;
                var validValues = {};
                validValues["value"] = obj.value.includes("|") ? obj.value : "";
                validValues["text"] = obj.value.includes("|") ? obj.value : "";
                rObj["validValues"] = validValues;
                rObj["type"] = obj.value.includes("|") ? "DropDown" : "Text";
                rObj["helpText"] = obj.name;
                rObj["mask"] = null;
                rObj["maxLength"] = null;
                rObj["required"] = obj.required;
                rObj["groupField"] = "pre1981";
                rObj["isShowMain"] = "False";
                rObj["isShowReport"] = "False";
                rObj["isInitialize"] = "False";
                rObj["disabled"] = null;
                return rObj;
            });
        }
    }
  let claimTypeItems = [];
  let value = ""
  if(workItem.dualFeesResponse.filter(a => a.fees !== null).length > 0){
    workItem.dualFeesResponse.forEach(fees => {
      const feeType = fees.fields.fieldDetails.filter(a => a.key === "cOwnerRet")[0].value;
      switch(feeType){
        case "No":
          value = "Insurer Retained";
          claimTypeItems.push(value);
          break;
        case "Yes":
          value = "Owner Retained";
          claimTypeItems.push(value);
          break;
      }
      if(fees.fees!==null){
        fees.fees.fees.forEach(fee => {
          fee.description.forEach(feeDesc => {
            const id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
            const newFeeMisc = [
              {
                  state: "",
                  sequence: `feeName${id}`,
                  name: feeDesc.name,
                  key: `MiscFee${id}`,
                  label: "Fee Name",
                  value: feeDesc.helpText,
                  validValues: {
                      value: "",
                      text: ""
                  },
                  fieldType: "Text",
                  helpText: "Fee Name",
                  mask: null,
                  maxLength: null,
                  required: "True",
                  disabled: null,
                  groupField: feeDesc.name,
              },
              {
                state: "",
                sequence: `feeAmount${id}`,
                name: feeDesc.name,
                key: `MiscFee${id}`,
                label: "Fee Amount",
                value: feeDesc.fullAmount,
                validValues: {
                    value: "",
                    text: ""
                },
                fieldType: "Currency",
                helpText: "Fee Amount",
                mask: null,
                maxLength: null,
                required: "True",
                disabled: null,
                groupField: feeDesc.name,
              },
              {
                state: "",
                sequence: `claimType${id}`,
                name: feeDesc.name,
                key: `MiscFee${id}`,
                label: "Claim Type",
                value: value,
                items: [],
                fieldType: "DropDown",
                helpText: "Claim Type",
                mask: null,
                maxLength: null,
                required: "True",
                disabled: null,
                groupField: feeDesc.name,
              }
            ];
            miscFees.push(newFeeMisc);
          });
        });
        miscFees.forEach(a =>{
          a.forEach(b => {
            if (b.sequence.includes("claimType")){
              b.items = claimTypeItems;
            }
          });
        });

      }
    });
    yield put(setMiscFeeValue(miscFees));

    }
    yield put(setPre1981DataValue(pre1981set));

  yield put(updateWorkItemAction(workItem));

  let rawFields = get(workItem, "dualFeesResponse[0].fields.fieldDetails", []);
  if (workItem.dualFeesResponse.length > 1) {
    rawFields = rawFields.map(field =>
      field.key === "cOwnerRet" ? { ...field, value: "Dual" } : field
    );
  }
  const fields = sanitizeWorkitemFields(rawFields);
  yield put(setFormFieldsAction(fields));

  yield call(delay, 0);

  yield call([history, "push"], "/questionnaire");
}

export function* fetchWorkItemsSaga() {
  const page = yield select(PaginationSelectors.getActivePage);
  const pageSize = yield select(PaginationSelectors.getDisplayingRows);
  const sortField = yield select(SortingSelectors.getSortField);
  const sortType = yield select(SortingSelectors.getSortType);
  const filter = yield select(selectWorkListFilters);

  const body = JSON.stringify(WorkItem.mapFilter(filter));
  const options = {
    method: "POST",
    body,
    headers: { "Content-Type": "application/json" }
  };

  try {
    const { workItemList, totalNumberOfRecords } = yield call(
      fetchSaga,
      fetchWorkItems,
      {
        page,
        pageSize,
        sortField,
        sortType,
        options
      }
    );

    const isMessageResponse =
      workItemList.length === 1 && workItemList[0].attributes === null;
    if (isMessageResponse) {
      yield put(fetchWorkItemSuccessAction([]));
      yield put(PaginationActions.setTotalRows(0));
    } else {
      yield put(fetchWorkItemSuccessAction(workItemList));
      yield put(PaginationActions.setTotalRows(Number(totalNumberOfRecords)));
    }
  } catch (error) {
    yield put(fetchWorkItemFailedAction(error));
  }
}

export function* selectDropdownStateSaga({ payload: value }) {
  yield put(
    setCurrentStateAction({
      abbr: value.value,
      name: value.text
    })
  );
}

export function* loadStateFieldsSaga({ payload: state }) {
  if (state === null) {
    return yield put(resetCurrentStateAction());
  }

  const fieldDetails = yield select(selectFieldDetails);
  const formFields = (fieldDetails || []).filter(x => x.state === state.value);
  yield put(selectDropdownStateAction(state));
  yield put(setFormFieldsAction(formFields));
}

export function* resetFormFieldsSaga() {
  const fieldDetails = yield select(selectFieldDetails);
  const formFields = (fieldDetails || []).filter(
    x => x.isInitialize === "True"
  );
  yield put(setFormFieldsAction(formFields));
}

export function* resetPaginationAndRefresh() {
  yield put(PaginationActions.resetPage());
  yield put(fetchWorkItemAction());
}

export function* refreshWorkList() {
  yield put(fetchWorkItemAction());
}

// function* resetWorkList() {
//   yield put(resetWorklistFilter());
//   yield put(PaginationActions.resetPage());
//   yield put({ type: actions.RESET_FILTER_INPUT });
// }

export function* resetEverythingAndRefresh() {
  yield put(resetWorklistFilter());
  yield put(PaginationActions.resetPage());
  yield put({ type: actions.RESET_FILTER_INPUT });
  yield put(fetchWorkItemAction());
}

export function* triggerFilterChangeOnOfficeChange(action) {
  yield put(
    changeWorklistFilter({ name: "ExternalId", value: action.payload.id })
  );
}

export function* fetchPreferences() {
  try {
    const preferences = yield call(getPreferences);
    const features = yield call(mapFeatures, preferences);

    yield put({ type: actions.SET_APP_FEATURES, payload: features });
    yield put({ type: actions.SET_PREFERENCES, payload: preferences });
  } catch (err) {
    console.log("Error getting preferences: ", err);
  }
}

export function* cloneWorkitemAction(data) {
  yield put(showLoader());
  let currentExternalId = yield select(getCurrentExternalId);
  if (currentExternalId === undefined){
    const preferences = yield call(getPreferences);
    currentExternalId = {id:preferences.attributes.externalId, name:preferences.attributes.externalId};
  }
  const workItem = yield call(fetchSaga, cloneWorkitem, {workitemId: data.workitemId, externalId: currentExternalId.id});
  yield put(
    setCurrentStateAction({
      abbr: null,
      name: null
    })
  );

  yield put(hideLoader());
  if(workItem.messages.some(a => a.key === "BadRequest")){
    yield put(apiRequestFailureAction(workItem));
    return;
  }

  if (get(workItem, "attributes.status").toUpperCase() === "COMPLETED") {
    yield put(setCurrentWorkItemAction(workItem));
    yield call(delay, 0);
    yield call([history, "push"], "/Summary");
    return;
  }

  yield put(updateWorkItemAction(workItem));

  let rawFields = get(workItem, "dualFeesResponse[0].fields.fieldDetails", []);
  if (workItem.dualFeesResponse.length > 1) {
    rawFields = rawFields.map(field =>
      field.key === "cOwnerRet" ? { ...field, value: "Dual" } : field
    );
  }
  const fields = sanitizeWorkitemFields(rawFields);
  yield put(setFormFieldsAction(fields));

  yield call(delay, 0);

  yield call([history, "push"], "/questionnaire");
}

// const isHomePage = ({ type, payload }) =>
//   type === LOCATION_CHANGE && payload.pathname === "/";

export const workItemsSagas = [
  takeLatest(actions.FETCH_INITIALIZE, fetchInitializeSaga),
  takeLatest(actions.FETCH_APP_DATA, fetchPreferences),
  takeLatest(actions.SELECT_WORKITEM, selectWorkItemSaga),
  takeEvery(actions.FETCH_WORK_ITEMS, fetchWorkItemsSaga),
  takeLatest(actions.LOAD_STATE_FIELDS, loadStateFieldsSaga),
  takeLatest(actions.SELECT_DROPDOWN_STATE, selectDropdownStateSaga),
  takeLatest(
    [
      actions.CANCEL_WORKITEM,
      actions.GENERATE_WORKITEM_REPORT_SUCCESS,
      actions.CREATE_WORK_ITEM_SUCCESS
    ],
    resetFormFieldsSaga
  ),
  takeLatest(
    [PaginationTypes.CHANGE_DISPLAYING, actions.CHANGE_WORKLIST_FILTER],
    resetPaginationAndRefresh
  ),
  takeLatest(
    [PaginationTypes.CHANGE_PAGE, SortTypes.SET_SORT],
    refreshWorkList
  ),
  // takeLatest(isHomePage, resetWorkList),
  takeLatest(actions.RESET_WORK_ITEMS, resetEverythingAndRefresh),
  takeLatest(actions.SET_USER_OFFICE, triggerFilterChangeOnOfficeChange),
  takeLatest(actions.CLONE_WORKITEM, cloneWorkitemAction)
];
